import * as React from 'react';
import EventStepper from '../../../../../components/EventStepper';
import { fm } from 'Components/FormatMessage';
import InputHandler from '../../../../../components/InputHandler';
import { formatPartialDate } from 'Utility/date';
import { StepperHeaderFormInputPair, StepperHeaderValuePair } from 'Components/EventStepper/components';

const Complications = ({ formData }: IOwnProps): React.JSX.Element => {
  return (
    <EventStepper
      name="complications"
      formData={formData}
      stepLabelText={(d: IRTMSComplication): string => formatPartialDate(d.date)}
      stepContent={(d: IRTMSComplication): React.JSX.Element => (
        <React.Fragment>
          {['complications', 'additionalInformation'].map((key, index) => {
            const value = d[key as keyof IRTMSComplication];
            return (
              <StepperHeaderValuePair
                key={`${key}${index}`}
                header={fm(`rtms.${key}`)}
                value={
                  value && (Array.isArray(value) ? value.length > 0 : true)
                    ? key === 'complications' && Array.isArray(value)
                      ? value.map(v => <div key={v}>{fm(`rtms.opts.complications.${v}`)}</div>)
                      : value
                    : '-'
                }
              />
            );
          })}
        </React.Fragment>
      )}
      addNewTextHeader="rtms.complications"
      addNewTextButton="rtms.newComplication"
      previousEventsTextHeader="rtms.previousComplications"
      editingElements={(index: number, onChange: IFormData['onChange']): React.JSX.Element => (
        <React.Fragment>
          <StepperHeaderFormInputPair
            header={fm('general.date')}
            input={
              <InputHandler
                type="PartialDate"
                editing={true}
                name="date"
                formData={{
                  onChange,
                  document: { date: formData.document.complications?.[index]?.date || '' },
                }}
                dateDefault="now"
                isNotCancellable={true}
                dateHook={{ dateHookFloor: formData.document.date ?? undefined }}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('rtms.complications')}
            input={
              <InputHandler
                type="Checkbox"
                editing={true}
                name="complications"
                formData={{
                  onChange,
                  document: { complications: formData.document.complications?.[index]?.complications || '' },
                }}
                options={[
                  'headache',
                  'bloodPressureReaction',
                  'dysrhythmia',
                  'allergicReation',
                  'aspirate',
                  'epilepticSpasm',
                ]}
                optionFormatter={(name: string | number): React.JSX.Element => fm(`rtms.opts.complications.${name}`)}
              />
            }
          />
          <StepperHeaderFormInputPair
            header={fm('rtms.additionalInformation')}
            input={
              <InputHandler
                type="TextArea"
                editing={true}
                name="additionalInformation"
                formData={{
                  onChange,
                  document: {
                    additionalInformation: formData.document.complications?.[index]?.additionalInformation || '',
                  },
                }}
                placeholder="rtms.additionalInformationComplications"
              />
            }
          />
        </React.Fragment>
      )}
    />
  );
};

interface IOwnProps {
  formData: IFormData<IRTMS>;
}

export default Complications;
